import tableRelatedAppTags from './tableRelatedAppTags';
import tableRelatedAppTags2 from './tableRelatedAppTags2';
import tableRelatedSportRoomTags from './tableRelatedSportRoomTags';

export default {
  title: 'Available tags',
  attributeName: 'appTags',
  getURL: 'appId/manualtags',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['appId'],
  tableConfig: tableRelatedSportRoomTags
};
